import type { I18nFn } from 'i18n/types/I18nFn';

export function LISTING_TYPE_HUMAN_NAME_MAP_TITLE(i18n: I18nFn) {
  return {
    JOB: i18n('Job'),
    INTERNSHIP: i18n('Internship'),
    VOLOP: i18n('Volunteer Opportunity'),
    ORG: i18n('Organization'),
    USER: i18n('User'),
    EVENT: i18n('Event'),
    CANDIDATE: i18n('a problem'),
  };
}

export const LISTING_TYPE_HUMAN_TRACKING_NAME_MAP_TITLE = {
  JOB: 'Job',
  INTERNSHIP: 'Internship',
  VOLOP: 'Volunteer Opportunity',
  ORG: 'Organization',
  USER: 'User',
  EVENT: 'Event',
  CANDIDATE: 'a problem',
};
